import axios from "axios";

const axiosInstance = axios.create();

export async function handleTokenRefresh() {
  if (typeof window === "undefined") {
    return null;
  }

  const storedAuthState = window.localStorage.getItem("authState");
  let parsedState = null;

  if (storedAuthState) {
    try {
      parsedState = JSON.parse(storedAuthState);
    } catch (error) {
      parsedState = null;
    }
  }

  const cachedToken = parsedState?.tokens?.accessToken || null;
  const refreshFn = window.__getAuth0Token;

  if (typeof refreshFn === "function") {
    try {
      const freshToken = await refreshFn();

      if (freshToken) {
        const updatedState = {
          ...(parsedState || {}),
          tokens: {
            ...((parsedState && parsedState.tokens) || {}),
            accessToken: freshToken,
          },
        };

        window.localStorage.setItem("authState", JSON.stringify(updatedState));
        return freshToken;
      }
    } catch (error) {
      console.error("Unable to refresh Auth0 token", error);
    }
  }

  return cachedToken;
}

axiosInstance.interceptors.request.use(
  async (config) => {
    const accessToken = await handleTokenRefresh();

    if (accessToken) {
      config.headers = {
        Authorization: "Bearer " + accessToken,
        ...config.headers,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong"
    )
);

export default axiosInstance;
